import { Component, Input } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlanAttributes, SummaryView } from '../../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../../plan-selection/interfaces/product.interface';
import { DOCTOR_VENDOR_TYPE } from '../configs/enums/doctor-vendor-type.enum';
import { DoctorVendorTypeState, DOCTOR_VENDOR_TYPE_STATE_REDUX_ID } from '../configs/reducers/doctor-information.reducer';

@Component({
    selector: 'app-doctor-detail',
    templateUrl: './doctor-detail.component.html',
    styleUrls: ['./doctor-detail.component.scss'],
    standalone: false
})
export class DoctorDetailComponent {

  @Input() plan: Product<PlanAttributes, SummaryView>;

  /** Set via global-hidden */
  vendorType: DOCTOR_VENDOR_TYPE;

  constructor(
    private reducerUtilityService: ReducerUtilityService
  ) { }

  ngOnInit() {
    const doctorVendorState: DoctorVendorTypeState = this.reducerUtilityService.getState(DOCTOR_VENDOR_TYPE_STATE_REDUX_ID);
    this.vendorType = doctorVendorState.vendorType;
  }

}
